import { Component } from '@angular/core';

/**
 * Embeds the static Vite build under /preview/React_Tailwind/.
 * The template uses HashRouter; `#/dashboard` matches Lovable Dashboard.tsx (feed), not the marketing Index page at `#/`.
 * Full-page static preview (no Angular shell): open `/preview/React_Tailwind/` — dev server serves the Vite `index.html` via proxy.conf.js.
 */
@Component({
    selector: 'app-preview-react-tailwind',
    template: `
        <div class="ts-preview-react-label">
            Lovable React + Tailwind (Vite static) — same source as <code>git/truth-first-look</code>, Dashboard route
        </div>
        <iframe
            class="ts-preview-react-frame"
            title="React Tailwind template (Lovable)"
            src="/preview/React_Tailwind/index.html#/dashboard"
        ></iframe>
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                height: 100vh;
                width: 100%;
                overflow: hidden;
            }
            .ts-preview-react-label {
                flex: 0 0 auto;
                padding: 0.35rem 0.75rem;
                font-size: 0.75rem;
                color: #64748b;
                background: #f1f5f9;
                border-bottom: 1px solid #e2e8f0;
            }
            .ts-preview-react-frame {
                flex: 1 1 auto;
                width: 100%;
                min-height: 0;
                border: 0;
                display: block;
            }
        `,
    ],
})
export class PreviewReactTailwindComponent {}
